import { render, staticRenderFns } from "./submissionDetails.vue?vue&type=template&id=ec42ead6&"
import script from "./submissionDetails.vue?vue&type=script&lang=js&"
export * from "./submissionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports